/**
 * @Author:      
 * @DateTime:    
 * @Description: 后台-登录管理-二级域名设置
 */
'use strict';
angular.module("setSubdomainsMgrModule", [
	'setSubdomainsMgrServiceModule', //二级域名设置弹窗
]).
controller('setSubdomainsMgrCtrl', ['$scope', '$validation', 'httpService', '$filter', '$state', 'modalDialog', 'Upload', '$timeout', "$q", "editPictureService", "setSubdomainsMgrService", '$location', function($scope, $validation, httpService, $filter, $state, modalDialog, Upload, $timeout, $q, editPictureService, setSubdomainsMgrService, $location) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			url: $location.url(),
			hasdomainPrefix: true,
		};
		$scope.data = {
			subdomainsname: '',
			suffix: "https://mcn.tianmuyun.cn/",
		};

	}

	$scope.setSubdomainsName = function() {
		$validation.validate($scope.setSubdomains).
		success(function() {
			setSubdomainsMgrService.backConfirmModal("域名设置", "域名设置后无法修改，确认使用该域名？", function() {
				var params = {
					domainPrefix: $scope.data.subdomainsname,
				};
				httpService.http("/mcnadmin/admin/tenant/editSecondDomain.do", params, "post", true, true).then(function(data) {
					if(data.success) {
						$state.go("backstage.loginPageMgr.setSuccess",{domainname:$scope.data.subdomainsname},{reload:'backstage.loginPageMgr.setSuccess'});
						$(".yindaoye").remove();
					} else if(!data.success) {
						modalDialog.alertType("域名设置失败", "该域名已被注册，请重新填写", "warning", false, function() {});
					}

				});

			});
		}).
		error(function() {

		});
	};

	/**
	 * [initData description] 初始化数据
	 * @return {[type]} [description]
	 */
	function initData() {
		getDomainInfo();
	}
	
	
	function getDomainInfo() {
		httpService.http("/mcnadmin/admin/tenant/getCurrTenantConfig.do", '', "post").then(function(data) {
			if(data.data && data.data.domainPrefix) {
				$scope.webUrl = data.webUrl
			}
		});
	}
}]);